import {
  faBriefcase,
  faEnvelope,
  faMapMarkedAlt,
  faPenSquare,
  faPhoneAlt,
  faPlus,
  faPlusCircle,
  faSchool,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { Route, HashRouter as Router, Switch, useLocation, useParams } from "react-router-dom";
import AvatarUpload from "./AvatarUpload";
import "react-quill/dist/quill.snow.css";

import wx from "weixin-js-sdk";
import { address as addressList } from "../address";
import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";
import { InputField, SelectField } from "./Components";
import dayjs from "dayjs";

const UserRouter = () => (
  <Router>
    <Switch>
      <Route exact path="/我的/简历/">
        <Resume />
      </Route>
      <Route exact path="/我的/简历/头像/:id">
        <AvatarUpload />
      </Route>
      <Route exact path="/我的/简历/个人信息/:id">
        <Personal />
      </Route>
      <Route exact path="/我的/简历/毕业院校/:id">
        <School />
      </Route>
      <Route exact path="/我的/简历/求职意向/:id">
        <Intention />
      </Route>
      <Route exact path="/我的/简历/自我评价/:id">
        <Evaluation />
      </Route>
      <Route exact path="/我的/简历/所在地/:id">
        <ProvinceCity />
      </Route>
      <Route exact path="/我的/简历/行业/:id">
        <Industry />
      </Route>
      <Route exact path="/我的/简历/项目经历/:id">
        <Project />
      </Route>
      <Route exact path="/我的/简历/工作经历/:id">
        <Work />
      </Route>
      <Route exact path="/我的/简历/求职状态/:id">
        <Status />
      </Route>
      <Route exact path="/我的/简历/证书/:id">
        <Certificate />
      </Route>
      <Route exact path="/我的/简历/专业技能/:id">
        <Skill />
      </Route>
    </Switch>
  </Router>
);

/**
 * 简历
 */
const Resume = () => {
  const [data, setData] = React.useState({
    phone: "",
    email: "",
    name: "",
    gender: "",
    birthday: "",
    addressLevel1: "",
    addressLevel2: "",
    addressLevel3: "",
    addressLevel4: "",
    school: "",
    education: "",
    major: "",
    dateBegin: "",
    dateEnd: "",
    qiwangzhiwei: "",
    qiwanghangye: "",
    yixiangchengshi: "",
    ziwopingjia: "",
    status: "",
    career: "[]",
    record: "[]",
    certificate: "[]",
    skill: "[]",
    json_doc: "{}",
  });
  // const [data1, setData1] = React.useState(0);
  const [resumeId, setResumeId] = React.useState(0);
  const [resumeUUid, setResumeUUid] = React.useState(0);
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [file, setFile] = React.useState("");
  const [flag, setFlag] = React.useState(false);
  const [avatarBase64, setAvatarBase64] = React.useState(null);
  const [careerlist, setCareerList] = React.useState([]);
  const [recordlist, setRecordList] = React.useState([]);
  const [certificatelist, setCertificateList] = React.useState([]);
  const [skilllist, setSkillList] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (auth !== null) {
      if (!auth.phone || auth.phone === "") {
        location.href = "#/我的/电话";
        return;
      }
      setLoading(true);
      fetch(`/gin-api/resume?option=filterBy-refId&refId=${auth.id}`)
        .then((response) => {
          if (response.status < 400) return response.json();
          if (response.status === 404) {
            // 404: 没查到简历，创建新简历
            return fetch("/gin-api/resume", {
              method: "POST",
              headers: { "content-type": "application/json" },
              body: JSON.stringify({
                id: 0,
                uuid: "",
                commonUserId: Number(auth.id),
                status: "",
                name: "",
                phone: "",
                email: "",
                gender: "",
                birthday: "",
                school: "",
                education: "",
                dateBegin: "",
                dateEnd: "",
                major: "",
                qiwangzhiwei: "",
                qiwanghangye: "",
                addressLevel1: "",
                addressLevel2: "",
                addressLevel3: "",
                yixiangchengshi: "",
                ziwopingjia: "",
                certificate: "[]",
                skill: "[]",
                career: "[]",
                record: "[]",
              }),
            }).then((res1) => {
              if (res1.status === 200 || res1.status === 201) {
                // 创建成功后重新获取简历数据
                return fetch(`/gin-api/resume?option=filterBy-refId&refId=${auth.id}`)
                  .then((res2) => res2.json());
              }
              throw new Error("创建简历失败");
            });
          }
          throw new Error("请求数据失败");
        })
        .then((data) => {
          // 检查数据是否有效（是否有 id）
          if (data && data.id && data.id !== 0) {
            setData({ ...data, dateBegin:data.date_begin, dateEnd:data.date_end, addressLevel1: data.address1, addressLevel2: data.address2, addressLevel3: data.address3 });
            setResumeId(data.id);
            setResumeUUid(data.uuid);
            if (document.getElementById("ziwopingjia") !== null) {
              document.getElementById("ziwopingjia").innerHTML = data.ziwopingjia;
            }
            // 解析头像的base64数据
            if (data.json_doc && data.json_doc !== "") {
              try {
                const jsonDocObj = JSON.parse(data.json_doc);
                if (jsonDocObj.avatar) {
                  setAvatarBase64(jsonDocObj.avatar);
                }
              } catch (err) {
                console.error("解析json_doc出错", err);
              }
            }
            if (data.career === null) {
              const career = [];
              const arr = [];
              career.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setCareerList(arr);
            } else {
              const arr = [];
              const career = JSON.parse(data.career);
              career.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setCareerList(arr);
            }
            if (data.record === null) {
              const record = [];
              const arr = [];
              record.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setRecordList(arr);
            } else {
              const arr = [];
              const record = JSON.parse(data.record);
              record.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setRecordList(arr);
            }
            if (data.certificate === null) {
              const certificate = [];
              const arr = [];
              certificate.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setCertificateList(arr);
            } else {
              const arr = [];
              const certificate = JSON.parse(data.certificate);
              certificate.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setCertificateList(arr);
            }
            if (data.skill === null) {
              const skill = [];
              const arr = [];
              skill.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setSkillList(arr);
            } else {
              const arr = [];
              const skill = JSON.parse(data.skill);
              skill.forEach((item) => {
                arr.push(JSON.parse(item));
              });
              setSkillList(arr);
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("获取简历数据失败:", err);
          setLoading(false);
        });
    }
  }, []);

  React.useEffect(() => {
    const getFile = async (resumeID) => {
      const response = await fetch(
        [
          "/crate-api-data/mysql/ovaphlow.file",
          `?f=eq,2,ref_id,${resumeID},act,2,tag,简历`,
          "&l=limit 1",
        ].join(""),
      );
      if (response.ok) {
        const data = await response.json();
        if (data.length > 0) {
          setFile(data[0].id);
        }
      }
    };
    if (auth !== null) {
      if (resumeId !== 0 && resumeUUid !== 0) {
        // fetch(`/api/miscellaneous/simple/file/${resumeId}?option=filterBy-ref`, {
        // 	method: "PATCH",
        // 	headers: { "content-type": "application/json" },
        // })
        // 	.then((res) => res.json())
        // 	.then((res) => {
        // 		setFile(res.id);
        // 	});
        try {
          getFile(resumeId);
        } catch (err) {
          console.error(err);
        }
      }
    }
  }, [resumeId, resumeUUid]);

  // React.useEffect(() => {
  //   if (auth !== null) {
  //     if (!auth.phone || auth.phone === '') {
  //       location.href = '#/我的/电话';
  //     }

  //     fetch(`/api/biz/simple/resume/RESUME_ID?option=status`)
  //       .then((res) => res.json())
  //       .then((res) => {
  //         console.log(res);
  //       })
  //   }
  // })

  const age = (birthday) => {
    if (birthday && birthday !== "") {
      return `${Number.parseInt(dayjs().format("YYYY"), 10) - Number.parseInt(birthday.slice(0, 4), 10)}岁`;
    }
    return "0岁";
  };

  // const changeStatus = (status) => {
  //   if (
  //     !data.phone ||
  //     data.phone === '' ||
  //     !data.email ||
  //     data.email === '' ||
  //     !data.name ||
  //     data.name === '' ||
  //     !data.gender ||
  //     data.gender === '' ||
  //     !data.birthday ||
  //     data.birthday === '' ||
  //     !data.address1 ||
  //     data.address1 === '' ||
  //     !data.address2 ||
  //     data.address2 === '' ||
  //     !data.address3 ||
  //     data.address3 === ''
  //   ) {
  //     alert('请您完善个人信息');
  //   } else if (
  //     !data.school ||
  //     data.school === '' ||
  //     !data.education ||
  //     data.education === '' ||
  //     !data.major ||
  //     data.major === '' ||
  //     !data.date_begin ||
  //     data.date_begin === '' ||
  //     !data.date_end ||
  //     data.date_end === ''
  //   ) {
  //     alert('请您完善毕业院校');
  //   } else {
  //     fetch(`/api/resume/${data.common_user_id}?option=status&uuid=${data.uuid}`, {
  //       method: 'PUT',
  //       headers: { 'content-type': 'application/json' },
  //       body: JSON.stringify({ status }),
  //     }).then((res) => {
  //       if (res.status !== 200) {
  //         console.info('服务器错误');
  //         return;
  //       }
  //       setData((p) => ({
  //         ...p,
  //         status,
  //       }));
  //       saveJournal({
  //         ref_id: auth.id,
  //         ref_id2: data.id,
  //         ref_uuid: auth.uuid,
  //         ref_uuid2: data.uuid,
  //         category: '修改简历状态',
  //         tag: '个人用户',
  //       });
  //     });
  //   }
  // };

  const handleFileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    if (e.target.files[0].size > 2097152) {
      alert("请上传2M以内的pdf文件");
      return;
    }
    const name = e.target.files[0].name;
    const filename = name.substring(name.lastIndexOf(".") + 1).toLowerCase();
    if (filename !== "pdf") {
      alert("请选择pdf格式文件上传");
      return;
    }
    if (e.target.files[0]) {
      setFlag(true);
      const formData = new FormData();
      formData.append("resume", e.target.files[0]);
      formData.append("tag", JSON.stringify(["简历"]));
      formData.append("detail", JSON.stringify({ uuid: resumeUUid }));
      formData.append("refId", resumeId);
      fetch("/api/miscellaneous/simple/file", {
        method: "POST",
        body: formData,
      }).then((response) => {
        if (200 == response.status || 201 === response.status) {
          alert("文件上传成功");
          window.location.reload();
          setFlag(false);
        } else {
          alert("文件上传失败，请稍后重试！");
        }
      });
    }
  };

  const handleAttachment = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          console.log("在小程序里");
          wx.miniProgram.navigateTo({
            url: `/pages/file-upload/file-upload?fileName=${file}&url=${encodeURIComponent(`https://www.longzhaopin.com/api/miscellaneous/simple/file/${resumeId}?option=by-ref`)}`,
          });
        } else {
          console.log("不在小程序里");
          fetch(`/api/miscellaneous/simple/file/${resumeId}?option=by-ref`).then((res) => {
            if (res.status === 200) {
              window.open(
                `https://www.longzhaopin.com/api/miscellaneous/simple/file/${resumeId}?option=by-ref`,
              );
            }
          });
        }
      });
    } else {
      console.log("不在微信中");
      fetch(`/api/miscellaneous/simple/file/${resumeId}?option=by-ref`).then((res) => {
        if (res.status === 200) {
          window.open(
            `https://www.longzhaopin.com/api/miscellaneous/simple/file/${resumeId}?option=by-ref`,
          );
        }
      });
    }
  };

  const handleUpload = () => {
    document.getElementById("file").click();
  };

  // const handleFileDelete = (id) => {
  //   fetch(`/api/common-user-file/${id}?user_id=${auth.id}`, {
  //     method: 'DELETE',
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       if (res.message) {
  //         alert(res.message);
  //       } else {
  //         _EditJournal(
  //           {
  //             category2: '简历',
  //             data_id: data.id,
  //             data_uuid: data.uuid,
  //             remark: '编辑我的证书',
  //           },
  //           () => {},
  //         );
  //         setFile((p) => p.filter((it) => it.id !== id));
  //       }
  //     });
  // };

  const handleLogIn = async () => {
    location.href = "#/登录?id=1";
  };

  const add_career = () => {
    sessionStorage.removeItem("career_data");
    location.href = `#/我的/简历/工作经历/${auth.id}?u_id=${auth.uuid}`;
  };

  const add_record = () => {
    sessionStorage.removeItem("record_data");
    location.href = `#/我的/简历/项目经历/${auth.id}?u_id=${auth.uuid}`;
  };

  const add_certificate = () => {
    sessionStorage.removeItem("certificate_data");
    location.href = `#/我的/简历/证书/${auth.id}?u_id=${auth.uuid}`;
  };

  const add_skill = () => {
    sessionStorage.removeItem("skill_data");
    location.href = `#/我的/简历/专业技能/${auth.id}?u_id=${auth.uuid}`;
  };

  const update_career = (el) => {
    const arr = [];
    JSON.parse(data.career)
      .filter((item, index) => index + 1 === el)
      .map((item) => {
        arr.push(item);
      });
    sessionStorage.setItem("career_data", arr);
    location.href = `#/我的/简历/工作经历/${auth.id}?u_id=${auth.uuid}&index=${el}`;
  };

  const update_record = (el) => {
    const arr = [];
    JSON.parse(data.record)
      .filter((item, index) => index + 1 === el)
      .map((item) => {
        arr.push(item);
      });
    sessionStorage.setItem("record_data", arr);
    location.href = `#/我的/简历/项目经历/${auth.id}?u_id=${auth.uuid}&index=${el}`;
  };

  const update_certificate = (el) => {
    const arr = [];
    JSON.parse(data.certificate)
      .filter((item, index) => index + 1 === el)
      .map((item) => {
        arr.push(item);
      });
    sessionStorage.setItem("certificate_data", arr);
    location.href = `#/我的/简历/证书/${auth.id}?u_id=${auth.uuid}&index=${el}`;
  };

  const update_skill = (el) => {
    const arr = [];
    JSON.parse(data.skill)
      .filter((item, index) => index + 1 === el)
      .map((item) => {
        arr.push(item);
      });
    sessionStorage.setItem("skill_data", arr);
    location.href = `#/我的/简历/专业技能/${auth.id}?u_id=${auth.uuid}&index=${el}`;
  };

  const delete_certificate = (el) => {
    if (confirm("确定要删除吗？")) {
      const arr1 = [];
      const arr = certificatelist.slice();
      arr.splice(el, 1);
      arr.forEach((item) => {
        arr1.push(JSON.stringify(item));
      });
      fetch(`/gin-api/resume/${data.uuid}/${data.id}?option=certificate`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          certificate: JSON.stringify(arr1),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            setCertificateList(arr);
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data.id,
              ref_uuid2: data.uuid,
              category: "移除简历证书",
              tag: "个人用户",
            });
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
      // fetch(`/api/biz/simple/resume/${data.id}?option=certificate`, {
      //   method: 'PUT',
      //   headers: { 'content-type': 'application/json' },
      //   body: JSON.stringify({ certificate: arr1 }),
      // }).then((res) => {
      //   console.log(res);
      //   if (res.status !== 200) {
      //     console.info('服务器错误');
      //     return;
      //   }
      //   setCertificateList(arr);
      //   saveJournal({
      //     ref_id: auth.id,
      //     ref_uuid: auth.uuid,
      //     ref_id2: data.id,
      //     ref_uuid2: data.uuid,
      //     category: '移除简历证书',
      //   });
      // });
    }
  };

  const delete_skill = (el) => {
    if (confirm("确定要删除吗？")) {
      const arr1 = [];
      const arr = skilllist.slice();
      arr.splice(el, 1);
      arr.forEach((item) => {
        arr1.push(JSON.stringify(item));
      });
      fetch(`/gin-api/resume/${data.uuid}/${data.id}?option=skill`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          skill: JSON.stringify(arr1),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            setSkillList(arr);
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data.id,
              ref_uuid2: data.uuid,
              category: "移除简历专业技能",
              tag: "个人用户",
            });
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
      // fetch(`/api/biz/simple/resume/${data.id}?option=skill`, {
      //   method: 'PUT',
      //   headers: { 'content-type': 'application/json' },
      //   body: JSON.stringify({ skill: arr1 }),
      // }).then((res) => {
      //   if (res.status !== 200) {
      //     console.info('服务器错误');
      //     return;
      //   }
      //   setSkillList(arr);
      //   saveJournal({
      //     ref_id: auth.id,
      //     ref_uuid: auth.uuid,
      //     ref_id2: data.id,
      //     ref_uuid2: data.uuid,
      //     category: '移除简历专业技能',
      //   });
      // });
    }
  };

  const delete_career = (el) => {
    if (confirm("确定要删除吗？")) {
      const arr1 = [];
      const arr = careerlist.slice();
      arr.splice(el, 1);
      arr.forEach((item) => {
        arr1.push(JSON.stringify(item));
      });
      fetch(`/gin-api/resume/${data.uuid}/${data.id}?option=career`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          career: JSON.stringify(arr1),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            setCareerList(arr);
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data.id,
              ref_uuid2: data.uuid,
              category: "移除简历工作经历",
              tag: "个人用户",
            });
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
      // fetch(`/api/resume/${data.commonUserId}?option=update-career`, {
      //   method: 'PUT',
      //   headers: { 'content-type': 'application/json' },
      //   body: JSON.stringify(arr1),
      // }).then((res) => {
      //   console.log(res);
      //   if (res.status !== 200) {
      //     console.info('服务器错误');
      //     return;
      //   }
      //   setCareerList(arr);
      //   saveJournal({
      //     ref_id: auth.id,
      //     ref_uuid: auth.uuid,
      //     ref_id2: data.id,
      //     ref_uuid2: data.uuid,
      //     category: '移除简历工作经历',
      //   });
      // });
    }
  };

  const delete_record = (el) => {
    if (confirm("确定要删除吗？")) {
      const arr1 = [];
      const arr = recordlist.slice();
      arr.splice(el, 1);
      arr.forEach((item) => {
        arr1.push(JSON.stringify(item));
      });
      fetch(`/gin-api/resume/${data.uuid}/${data.id}?option=record`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          record: JSON.stringify(arr1),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            setRecordList(arr);
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data.id,
              ref_uuid2: data.uuid,
              category: "移除简历项目经历",
              tag: "个人用户",
            });
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
      // fetch(`/api/resume/${data.commonUserId}?option=update-record`, {
      //   method: 'PUT',
      //   headers: { 'content-type': 'application/json' },
      //   body: JSON.stringify(arr1),
      // }).then((res) => {
      //   if (res.status !== 200) {
      //     console.info('服务器错误');
      //     return;
      //   }
      //   setRecordList(arr);
      //   saveJournal({
      //     ref_id: auth.id,
      //     ref_uuid: auth.uuid,
      //     ref_id2: data.id,
      //     ref_uuid2: data.uuid,
      //     category: '移除简历项目经历',
      //     tag: '个人用户',
      //   });
      // });
    }
  };

  const delete_resume = () => {
    if (!window.confirm("确定要删除当前数据？")) return;
    fetch(`/api/miscellaneous/simple/file/${resumeId}?option=removeBy-refId`, {
      method: "DELETE",
    }).then((response) => {
      if (response.status === 200) {
        window.alert("删除成功!");
        window.location.reload();
      } else {
        window.alert("操作失败!");
      }
    });
  };

  return (
    <>
      {auth === null ? (
        <div className="container-fluid">
          <ToBack href="#我的" category="我的简历" />
          <div className="chat-login">
            <h6>登录后可以查看简历</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid background-login1" style={{ fontSize: 14 }}>
          {/* <div className="row mt-2">
            <div className="col" >
              <img style={{ height: 60 }} src="lib/img/user.jpg" alt="" />
            </div>
            <div className="col-9 " style={{ paddingLeft: 0 }}>
              <div className="pull-left">
                <span style={{ fontSize: 18 }}>{data.name}</span>
                <span>/{!data.gender || (data.gender === '男' ? '先生' : '女士')}</span>
                <br />
                {age(data.birthday)} | {data.address1}-{data.address2}-{data.address3}
              </div>
              <div className="pull-right">
                <a href={`#/我的/简历/个人信息/${auth.id}?u_id=${auth.uuid}`}>
                  <i className="fa fa-pencil-square-o fa-fw"></i>
                  编辑
                </a>
              </div>
            </div>
          </div> */}
          <div className="card mt-3 user-radius border-0 mb-5">
            <ToBack category="我的简历" refresh resumeId={resumeId} resumeUUid={`${resumeUUid}`} />
            {loading && (
              <div className="loading-overlay" style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
              }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <span className="ml-2">加载中...</span>
              </div>
            )}
            <div className="card-body">
              <div className="mb-2 resume-personal pt-2 pb-1 text-center">
                <h6>简历预览</h6>
              </div>
              <div className="row mt-2 mb-2 justify-content-center">
                {avatarBase64 ? (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={avatarBase64}
                      alt="用户头像"
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginBottom: "10px",
                        opacity: loading ? 0.5 : 1,
                      }}
                    />
                    <br />
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      disabled={loading}
                      onClick={() => (location.href = `#/我的/简历/头像/${auth.id}`)}
                    >
                      更换头像
                    </button>
                  </div>
                ) : (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    disabled={loading}
                    onClick={() => (location.href = `#/我的/简历/头像/${auth.id}`)}
                  >
                    上传头像
                  </button>
                )}
              </div>
              <div className="row">
                <div className="col">
                  <span style={{ fontSize: "1.25rem" }}>{data.name}</span>
                  <span>/{!data.gender || (data.gender === "男" ? "先生" : "女士")}</span>
                </div>
                <div className="col">
                  <span
                    className={`pull-right ${loading ? "text-muted" : "text-primary"}`}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    onClick={() => !loading && (location.href = `#/我的/简历/个人信息/${auth.id}?u_id=${auth.uuid}`)}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    {loading ? "编辑" : "编辑"}
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {age(data.birthday)} |{data.addressLevel1}-{data.addressLevel2}-
                  {data.addressLevel3}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col">
                  <FontAwesomeIcon icon={faPhoneAlt} fixedWidth />
                  {data.phone}
                </div>
              </div>
              <div className="row mt-1">
                <div className="col">
                  <FontAwesomeIcon icon={faEnvelope} fixedWidth />
                  {data.email}
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col">
                  <h5>毕业院校</h5>
                </div>
                <div className="col">
                  <span
                    className={`pull-right ${loading ? "text-muted" : "text-primary"}`}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    onClick={() => !loading && (location.href = `#/我的/简历/毕业院校/${auth.id}?u_id=${auth.uuid}`)}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    编辑
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <FontAwesomeIcon icon={faSchool} fixedWidth />
                  <strong style={{ fontSize: 15 }}>{data.school}</strong>
                  <br />
                  &nbsp;
                  <span className="text-muted" style={{ fontSize: 14 }}>
                    {data.dateBegin} -{data.dateEnd}
                  </span>
                  <br />
                  {data.education} |{data.major}
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col">
                  <h5>求职意向</h5>
                </div>
                <div className="col">
                  <span
                    className={`pull-right ${loading ? "text-muted" : "text-primary"}`}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    onClick={() => !loading && (location.href = `#/我的/简历/求职意向/${auth.id}?u_id=${auth.uuid}`)}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    编辑
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div>
                    <FontAwesomeIcon icon={faMapMarkedAlt} fixedWidth />
                    {data.yixiangchengshi}
                  </div>

                  <div className="mt-1">
                    <FontAwesomeIcon icon={faBriefcase} fixedWidth />
                    {data.qiwanghangye}-{data.qiwangzhiwei}
                  </div>
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col">
                  <h5>求职状态</h5>
                </div>
                <div className="col">
                  <span
                    className={`pull-right ${loading ? "text-muted" : "text-primary"}`}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    onClick={() => !loading && (location.href = `#/我的/简历/求职状态/${auth.id}?u_id=${auth.uuid}`)}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    编辑
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div>
                    <FontAwesomeIcon icon={faPlusCircle} fixedWidth />
                    {data.status}
                  </div>
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col">
                  <h5>
                    证书 <span style={{ fontSize: 10, color: "red" }}>（如无，可不填写）</span>
                  </h5>
                </div>
                <div className="col">
                  <button
                    className={`pull-right border-0 bg-transparent ${loading ? "text-muted" : "text-primary"}`}
                    disabled={loading}
                    onClick={add_certificate}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    添加
                  </button>
                </div>
              </div>

              {certificatelist &&
                certificatelist.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col">
                      <strong style={{ fontSize: 15 }}>
                        证书名称:
                        {item.certificate}
                        <div className="pull-right">
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-success"}`}
                            disabled={loading}
                            onClick={() => update_certificate(index + 1)}
                          >
                            修改
                          </button>
                          &nbsp;&nbsp;
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-danger"}`}
                            disabled={loading}
                            onClick={() => delete_certificate(index)}
                          >
                            删除
                          </button>
                        </div>
                      </strong>
                      <div className="mt-1">
                        获得时间:
                        {item.time}
                      </div>
                    </div>
                  </div>
                ))}

              <hr />

              <div className="row">
                <div className="col-8">
                  <h5>
                    专业技能<span style={{ fontSize: 10, color: "red" }}>（如无，可不填写）</span>
                  </h5>
                </div>
                <div className="col">
                  <button
                    className={`pull-right border-0 bg-transparent ${loading ? "text-muted" : "text-primary"}`}
                    disabled={loading}
                    onClick={add_skill}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    添加
                  </button>
                </div>
              </div>

              {skilllist &&
                skilllist.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col">
                      <strong style={{ fontSize: 15 }}>
                        技能名称:
                        {item.name}
                        <div className="pull-right">
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-success"}`}
                            disabled={loading}
                            onClick={() => update_skill(index + 1)}
                          >
                            修改
                          </button>
                          &nbsp;&nbsp;
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-danger"}`}
                            disabled={loading}
                            onClick={() => delete_skill(index)}
                          >
                            删除
                          </button>
                        </div>
                      </strong>
                      <div className="mt-1">
                        使用时长:
                        {item.length}个月
                      </div>
                      <div className="mt-1">
                        掌握程度:
                        {item.level}
                      </div>
                    </div>
                  </div>
                ))}

              <hr />

              <div className="row">
                <div className="col-8">
                  <h5>
                    工作经历<span style={{ fontSize: 10, color: "red" }}>（如无，可不填写）</span>
                  </h5>
                </div>
                <div className="col">
                  <button
                    className={`pull-right border-0 bg-transparent ${loading ? "text-muted" : "text-primary"}`}
                    disabled={loading}
                    onClick={add_career}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    添加
                  </button>
                </div>
              </div>

              {careerlist &&
                careerlist.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col">
                      <strong style={{ fontSize: 15 }}>
                        公司名称:
                        {item.employer}
                        <div className="pull-right">
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-success"}`}
                            disabled={loading}
                            onClick={() => update_career(index + 1)}
                          >
                            修改
                          </button>
                          &nbsp;&nbsp;
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-danger"}`}
                            disabled={loading}
                            onClick={() => delete_career(index)}
                          >
                            删除
                          </button>
                        </div>
                      </strong>
                      <div className="mt-1">
                        职位名称:
                        {item.title}
                      </div>
                      <div className="mt-1">
                        在职时间:
                        {item.date_begin}&nbsp;-&nbsp;{item.date_end}
                      </div>
                      <div className="mt-1">
                        工作描述:
                        {item.description}
                      </div>
                    </div>
                  </div>
                ))}

              <hr />

              <div className="row">
                <div className="col-8">
                  <h5>
                    项目经历<span style={{ fontSize: 10, color: "red" }}>（如无，可不填写）</span>
                  </h5>
                </div>
                <div className="col">
                  <button
                    className={`pull-right border-0 bg-transparent ${loading ? "text-muted" : "text-primary"}`}
                    disabled={loading}
                    onClick={add_record}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    添加
                  </button>
                </div>
              </div>
              {recordlist &&
                recordlist.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col">
                      <strong style={{ fontSize: 15 }}>
                        项目名称:
                        {item.name}
                        <div className="pull-right">
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-success"}`}
                            disabled={loading}
                            onClick={() => update_record(index + 1)}
                          >
                            修改
                          </button>
                          &nbsp;&nbsp;
                          <button
                            className={`border-0 bg-transparent ${loading ? "text-muted" : "text-danger"}`}
                            disabled={loading}
                            onClick={() => delete_record(index)}
                          >
                            删除
                          </button>
                        </div>
                      </strong>
                      <div className="mt-1">
                        项目职位:
                        {item.title}
                      </div>
                      <div className="mt-1">
                        项目时间:
                        {item.date_begin}&nbsp;-&nbsp;{item.date_end}
                      </div>
                      <div className="mt-1">
                        项目职责:
                        {item.role}
                      </div>
                      <div className="mt-1">
                        项目描述:
                        {item.description}
                      </div>
                    </div>
                  </div>
                ))}

              <hr />

              <div className="row">
                <div className="col">
                  <h5>自我评价</h5>
                </div>
                <div className="col">
                  <span
                    className={`pull-right ${loading ? "text-muted" : "text-primary"}`}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    onClick={() => !loading && (location.href = `#/我的/简历/自我评价/${auth.id}?u_id=${auth.uuid}`)}
                  >
                    <FontAwesomeIcon icon={faPenSquare} fixedWidth />
                    编辑
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col" id="ziwopingjia" />
              </div>
              <hr />
              <div className="row mb-2">
                <div className="col-7 flex-start">
                  <h5>
                    上传简历附件
                    <p className="text-danger" style={{ fontSize: 14 }}>
                      (请上传2M以内的pdf文件)
                    </p>
                  </h5>
                </div>
                <div className="col-5">
                  <div className="row">
                    <button
                      type="button"
                      className={`btn btn-primary btn-sm pull-right ${loading ? "disabled" : ""}`}
                      disabled={loading}
                      onClick={handleUpload}
                    >
                      <FontAwesomeIcon icon={faPlus} fixedWidth />
                      上传
                    </button>
                    <button
                      type="button"
                      className={`btn btn-primary btn-sm pull-right ${loading ? "disabled" : ""}`}
                      disabled={loading}
                      onClick={delete_resume}
                    >
                      删除
                    </button>
                  </div>
                  <input
                    type="file"
                    id="file"
                    accept="application/pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </div>
              </div>
              {file !== "" && flag === false ? (
                <div className="row">
                  <button
                    className={`border-0 btn btn-link ${loading ? "text-muted" : "text-primary"}`}
                    style={{ fontSize: 15, cursor: loading ? "not-allowed" : "pointer" }}
                    disabled={loading}
                    onClick={handleAttachment}
                  >
                    {file}.pdf
                  </button>
                </div>
              ) : (
                <div>
                  {flag === false ? (
                    <div className="d-flex justify-content-center">
                      <span>您还没有上传简历附件</span>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <span>正在上传，请稍后...</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* {auth === null ? (
        <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top" style={{ display: 'none' }}>
          <div className="row text-center nav-row">
            {data.status === '保密' ? (
              <button
                type="button"
                className="btn btn-primary nav-btn"
                onClick={() => changeStatus('公开')}
              >
                公开简历
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-danger nav-btn"
                onClick={() => changeStatus('保密')}
              >
                停止公开
              </button>
            )}
          </div>
        </ul>
      ) : (
        <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
          <div className="row text-center nav-row">
            {data.status === '保密' ? (
              <button
                type="button"
                className="btn btn-primary nav-btn"
                onClick={() => changeStatus('公开')}
              >
                公开简历
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-danger nav-btn"
                onClick={() => changeStatus('保密')}
              >
                停止公开
              </button>
            )}
          </div>
        </ul>
      )} */}
    </>
  );
};

const Personal = () => {
  const [data, setData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const auth = JSON.parse(localStorage.getItem("auth"));

  const { id } = useParams();

  const { search } = useLocation();

  useEffect(() => {
    if (!auth) {
      alert("请先登录");
      location.href = "#/登录?id=1";
      return;
    }

    if (!loaded) {
      fetch(`/gin-api/resume?option=filterBy-refId&refId=${auth.id}`)
        .then((response) => {
          if (response.status < 400) return response.json();
          throw new Error("请求数据失败");
        })
        .then((fetchedData) => {
          // 处理字段名映射：addressLevel1/2/3 -> address1/2/3
          const dataWithMapping = {
            ...fetchedData,
            address1: fetchedData.addressLevel1 || fetchedData.address1 || "",
            address2: fetchedData.addressLevel2 || fetchedData.address2 || "",
            address3: fetchedData.addressLevel3 || fetchedData.address3 || "",
          };

          // 合并 sessionStorage 中的编辑数据（排除地址字段）
          const savedData = sessionStorage.getItem("resume_data");
          if (savedData) {
            try {
              const parsedData = JSON.parse(savedData);
              // 保留用户编辑的非地址字段
              const mergedData = {
                ...dataWithMapping,
                name: parsedData.name || dataWithMapping.name,
                gender: parsedData.gender || dataWithMapping.gender,
                birthday: parsedData.birthday || dataWithMapping.birthday,
                phone: parsedData.phone || dataWithMapping.phone,
                email: parsedData.email || dataWithMapping.email,
              };
              setData(mergedData);
            } catch (e) {
              console.error("解析 sessionStorage 数据失败:", e);
              setData(dataWithMapping);
            }
          } else {
            setData(dataWithMapping);
          }
          setLoaded(true);
        })
        .catch((err) => {
          console.error("获取简历数据失败:", err);
          alert("获取简历数据失败，请稍后重试");
        });
    }
  }, [auth, loaded]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => {
      const newData = { ...prev, [name]: value };
      // 居住地字段不保存到 sessionStorage，由 ProvinceCity 保存后从服务器获取
      if (!["address1", "address2", "address3"].includes(name)) {
        sessionStorage.setItem("resume_data", JSON.stringify(newData));
      }
      return newData;
    });
  };

  const handleSave = () => {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (!reg.test(data.phone)) {
      window.alert("请检查手机号是否正确！");
      return;
    }
    // 创建完整数据对象，包含所有必要的字段
    const saveData = {
      ...data,
      addressLevel1: data.address1 || data.addressLevel1 || "",
      addressLevel2: data.address2 || data.addressLevel2 || "",
      addressLevel3: data.address3 || data.addressLevel3 || "",
      addressLevel4: data.address4 || data.addressLevel4 || "",
      dateBegin: data.date_begin,
      dateEnd: data.date_end,
    };

    fetch(`/gin-api/resume/${saveData.uuid}/${saveData.id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(saveData),
    })
      .then((response) => {
        if (response.status < 400) {
          // 检查响应的 Content-Type 来确定是否解析为 JSON
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            return response.json();
          } else {
            // 如果不是 JSON，直接返回 OK 字符串
            return response.text();
          }
        } else {
          throw new Error(`保存失败，状态码: ${response.status}`);
        }
      })
      .then((responseData) => {
        // 保存成功后清理 sessionStorage
        sessionStorage.removeItem("resume_data");
        saveJournal({
          ref_id: auth.id,
          ref_uuid: auth.uuid,
          ref_id2: saveData.id,
          ref_uuid2: saveData.uuid,
          category: "修改简历个人信息",
          tag: "个人用户",
        });
        history.back();
      })
      .catch((err) => {
        console.error("保存失败:", err);
        alert(`保存失败: ${err.message}`);
      });
  };

  const toProvinceCity = () => {
    // 清理 sessionStorage 中的地址数据，确保返回时从服务器获取最新值
    const savedData = sessionStorage.getItem("resume_data");
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        delete parsedData.address1;
        delete parsedData.address2;
        delete parsedData.address3;
        sessionStorage.setItem("resume_data", JSON.stringify(parsedData));
      } catch (e) {
        console.error("处理 sessionStorage 数据失败:", e);
      }
    }
    location.href = `#/我的/简历/所在地/${id}${search}`;
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>个人信息</h6>
            </div>
            <div className="row mt-3 p-1">
              <InputField
                name="name"
                category="姓名"
                value={data.name}
                placeholder="请填写姓名"
                handleChange={handleChange}
              />
            </div>
            <div className="row p-1">
              <SelectField
                name="gender"
                category="性别"
                value={data.gender}
                placeholder="请选择性别"
                handleChange={handleChange}
              >
                <option> </option>
                <option>男</option>
                <option>女</option>
              </SelectField>
            </div>
            <div className="form-group row input-label">
              <label className="col-4 col-form-label text-right text-muted">出生日期</label>
              <div className="col-8">
                <input
                  type="date"
                  name="birthday"
                  value={data.birthday || ""}
                  className="form-control-plaintext input-f"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row p-1" onClick={toProvinceCity} aria-hidden="true">
              <InputField
                name="address1"
                category="现居住地"
                value={`${data.address1 || ""}-${data.address2 || ""}-${data.address3 || ""}`}
                placeholder="请提供现居住地"
                handleChange={handleChange}
              />
            </div>
            <div className="row p-1">
              <InputField
                name="phone"
                category="手机号码"
                value={data.phone}
                handleChange={handleChange}
              />
            </div>
            <div className="row p-1">
              <InputField
                name="email"
                category="电子邮箱"
                value={data.email}
                placeholder="请提供电子邮箱"
                handleChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

const School = () => {
  const [data, setData] = useState({});
  const { id } = useParams();
  const auth = JSON.parse(localStorage.getItem("auth"));

  useEffect(() => {
    if (!auth) {
      alert("请先登录");
      location.href = "#/登录?id=1";
      return;
    }

    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        data.dateBegin = data.date_begin;
        data.dateEnd = data.date_end;
        setData(data);
      })
      .catch((err) => {
        console.error("获取简历数据失败:", err);
        alert("获取简历数据失败，请稍后重试");
      });
  }, []);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    fetch(`/gin-api/resume/${data.uuid}/${data.id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ...data,
        addressLevel1: data.address1,
        addressLevel2: data.address2,
        addressLevel3: data.address3,
        addressLevel4: data.address4,
      }),
    })
      .then((response) => {
        if (response.status < 400) {
          saveJournal({
            ref_id: auth.id,
            ref_uuid: auth.uuid,
            ref_id2: data.id,
            ref_uuid2: data.uuid,
            category: "修改简历毕业院校",
            tag: "个人用户",
          });
          history.back();
        } else {
          throw new Error(`保存失败，状态码: ${response.status}`);
        }
      })
      .catch((err) => {
        console.error("保存失败:", err);
        alert(`保存失败: ${err.message}`);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>毕业院校</h6>
            </div>
            <div className="row">
              <InputField
                name="school"
                category="毕业院校"
                value={data.school}
                placeholder="请提供现毕业院校"
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <SelectField
                name="education"
                category="学历"
                value={data.education}
                placeholder="请提供现学历"
                handleChange={handleChange}
              >
                <option> </option>
                <option>高中及以下</option>
                <option>大专</option>
                <option>本科</option>
                <option>硕士</option>
                <option>博士</option>
              </SelectField>
            </div>
            <div className="row">
              <InputField
                name="major"
                category="专业名称"
                value={data.major}
                placeholder="如: 计算机科学与技术"
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">入学时间</label>
                <div className="col">
                  <input
                    type="date"
                    name="dateBegin"
                    value={data.dateBegin || ""}
                    className="form-control-plaintext input-f"
                    placeholder="入学时间"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">毕业时间</label>
                <div className="col">
                  <input
                    type="date"
                    name="dateEnd"
                    value={data.dateEnd || ""}
                    className="form-control-plaintext input-f"
                    placeholder="毕业时间"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

const Intention = () => {
  const [data, setData] = useState({});
  const auth = JSON.parse(localStorage.getItem("auth"));
  const { id } = useParams();

  const { search } = useLocation();

  useEffect(() => {
    const _data = JSON.parse(sessionStorage.getItem("industry_data"));
    if (_data !== null) {
      setData(_data);
    } else {
      fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
        .then((response) => {
          if (response.status < 400) return response.json();
          throw new Error("请求数据失败");
        })
        .then((data) => {
          setData(data);
        });
      // fetch(`/api/resume/user/${id}${search}`)
      //   .then((res) => res.json())
      //   .then((res) => {
      //     if (res) {
      //       setData(res);
      //     } else {
      //       console.info(res);
      //     }
      //   });
    }
    sessionStorage.removeItem("industry_data");
  }, [id]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    fetch(`/gin-api/resume/${data.uuid}/${data.id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ...data,
        addressLevel1: data.address1 || data.addressLevel1 || "",
        addressLevel2: data.address2 || data.addressLevel2 || "",
        addressLevel3: data.address3 || data.addressLevel3 || "",
        addressLevel4: data.address4 || data.addressLevel4 || "",
        dateBegin: data.date_begin,
        dateEnd: data.date_end,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          saveJournal({
            ref_id: auth.id,
            ref_uuid: auth.uuid,
            ref_id2: data.id,
            ref_uuid2: data.uuid,
            category: "修改简历求职意向",
            tag: "个人用户",
          });
          history.back();
        } else throw new Error("操作失败");
      })
      .catch((err) => alert(err));
  };

  const toIndustry = () => {
    location.href = `#/我的/简历/行业/${id}${search}`;
    sessionStorage.setItem("industry_data", JSON.stringify(data));
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>求职意向</h6>
            </div>

            <div aria-hidden="true" className="row mt-3" onClick={toIndustry}>
              <InputField
                name="qiwangzhiwei"
                category="期望职位"
                value={`${data.qiwanghangye}-${data.qiwangzhiwei}`}
                handleChange={handleChange}
              />
            </div>
            <div className="row ">
              <InputField
                name="yixiangchengshi"
                category="工作地点"
                value={data.yixiangchengshi}
                handleChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

const Evaluation = () => {
  const [data, setData] = useState({});
  const auth = JSON.parse(localStorage.getItem("auth"));

  const { id } = useParams();

  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setData(data);
        setContent(data.ziwopingjia);
      });
  }, [id]);

  const handleSave = () => {
    fetch(`/gin-api/resume/${data.uuid}/${data.id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ...data,
        addressLevel1: data.address1 || data.addressLevel1 || "",
        addressLevel2: data.address2 || data.addressLevel2 || "",
        addressLevel3: data.address3 || data.addressLevel3 || "",
        addressLevel4: data.address4 || data.addressLevel4 || "",
        dateBegin: data.date_begin,
        dateEnd: data.date_end,
        ziwopingjia: content,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          saveJournal({
            ref_id: auth.id,
            ref_uuid: auth.uuid,
            ref_id2: data.id,
            ref_uuid2: data.uuid,
            category: "修改简历自我评价",
            tag: "个人用户",
          });
          history.back();
        } else throw new Error("操作失败");
      })
      .catch((err) => alert(err));
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>自我评价</h6>
            </div>
            <div className="row mt-3">
              <div className="col">
                <div className="form-group">
                  <ReactQuill
                    formats={["header", "align", "bold", "italic", "underline", "blockquote"]}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, false] }],
                        [{ align: [] }],
                        ["bold", "italic", "underline", "blockquote"],
                      ],
                    }}
                    placeholder="请填写内容"
                    value={content || ""}
                    onChange={setContent}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

const ProvinceCity = () => {
  const [level1, setLevel1] = useState("");
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [level2, setLevel2] = useState("");
  const [level2List, setLevel2List] = useState([]);
  const [level3, setLevel3] = useState("");
  const [level3List, setLevel3List] = useState([]);
  const [resume, setResume] = useState({});
  const { id } = useParams();
  // const { search } = useLocation();
  const [level, setLevel] = useState([]);
  const [address, setAddress] = useState([]);

  useEffect(() => {
    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        if (data) {
          setResume(data);
          // fetch("/wx/lib/address.json")
          //   .then((res1) => res1.json())
          //   .then((res1) => {
          // setAddress(res1);
          setAddress(addressList);
          const _level = Object.getOwnPropertyNames(addressList)
            .filter((item) => item.slice(2, 7) === "0000")
            .map((code) => ({
              code,
              name: addressList[code],
            }));
          setLevel(_level);

          if (data.addressLevel1) {
            const l1 = _level.find((item) => item.name === data.addressLevel1);
            if (l1) {
              const _level2 = Object.getOwnPropertyNames(addressList)
                .filter((it) => {
                  return (
                    l1.code.slice(0, 2) === it.slice(0, 2) &&
                    it.slice(4, 7) === "00" &&
                    it !== l1.code
                  );
                })
                .map((code) => ({
                  code,
                  name: addressList[code],
                }));
              setLevel2List(_level2);
              const l2 = _level2.find((item) => item.name === data.addressLevel2);
              if (l2) {
                setLevel3List(
                  Object.getOwnPropertyNames(addressList)
                    .filter((it) => l2.code.slice(0, 4) === it.slice(0, 4) && it !== l2.code)
                    .map((code) => ({
                      code,
                      name: addressList[code],
                    })),
                );
              }
            }
          }
          setLevel1(data.addressLevel1);
          setLevel2(data.addressLevel2);
          setLevel3(data.addressLevel3);
          // });
        } else {
          console.info("服务器错误");
        }
      });
  }, [id]);

  const level1Click = (item) => {
    setLevel1(item.name);
    setLevel2("");
    setLevel3("");
    setLevel3List([]);
    setLevel2List(
      Object.getOwnPropertyNames(address)
        .filter((it) => {
          return (
            item.code.slice(0, 2) === it.slice(0, 2) && it.slice(4, 7) === "00" && it !== item.code
          );
        })
        .map((code) => ({
          code,
          name: address[code],
        })),
    );
  };

  const level2Click = (item) => {
    setLevel2(item.name);
    setLevel3("");
    setLevel3List(
      Object.getOwnPropertyNames(address)
        .filter((it) => item.code.slice(0, 4) === it.slice(0, 4) && it !== item.code)
        .map((code) => ({
          code,
          name: address[code],
        })),
    );
  };
  const level3Click = (item) => {
    setLevel3(item.name);
  };

  const _class = (it1, it2) => (it1 === it2.name ? "text-primary font-weight-bold" : "text-muted");

  const handleSave = () => {
    fetch(`/gin-api/resume/${resume.uuid}/${resume.id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ...resume,
        addressLevel1: level1,
        addressLevel2: level2,
        addressLevel3: level3,
        dateBegin: resume.date_begin,
        dateEnd: resume.date_end,
      }),
    }).then((res) => {
      if (res.status !== 200) {
        return;
      }
      const resume_data = JSON.parse(sessionStorage.getItem("resume_data"));
      if (resume_data !== null) {
        setResume(resume_data);
      }
      sessionStorage.setItem(
        "resume_data",
        JSON.stringify({
          ...resume_data,
          addressLevel1: level1,
          addressLevel2: level2,
          addressLevel3: level3,
          dateBegin: resume_data.date_begin,
          dateEnd: resume_data.date_end,
        }),
      );
      saveJournal({
        ref_id: auth.id,
        ref_uuid: auth.uuid,
        ref_id2: resume.id,
        ref_uuid2: resume.uuid,
        category: "修改简历个人信息",
        tag: "个人用户",
      });
      // _EditJournal(
      //   {
      //     category: '简历',
      //     data_id: resume.id,
      //     data_uuid: resume.uuid,
      //     remark: '修改简历个人信息',
      //   },
      //   () => {},
      // );
      history.back();
    });
    // .then((res) => res.json())
    // .then((res) => {
    //   if (res.message) {
    //     console.info('服务器错误');
    //   } else {
    //     const resume_data = JSON.parse(sessionStorage.getItem('resume_data'));
    //     if (resume_data !== null) {
    //       setResume(resume_data);
    //     }
    //     sessionStorage.setItem(
    //       'resume_data',
    //       JSON.stringify({
    //         ...resume_data,
    //         address1: level1,
    //         address2: level2,
    //         address3: level3,
    //       }),
    //     );
    //     _EditJournal(
    //       {
    //         category2: '简历',
    //         data_id: resume.id,
    //         data_uuid: resume.uuid,
    //         remark: '修改简历个人信息',
    //       },
    //       () => {},
    //     );
    //     history.back();
    //   }
    // });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded shadow">
          <br />
          <ToBack />
          <div className="card-body">
            <div className="mt-2">
              <h4>请选择现居住地</h4>
            </div>
            <hr />
            <div className="row mt-3" style={{ fontSize: 14 }}>
              <div className="col pre-scrollable">
                {level.map((item) => (
                  <p
                    aria-hidden="true"
                    className={_class(level1, item)}
                    onClick={() => {
                      level1Click(item);
                    }}
                    key={item.code}
                  >
                    {item.name}
                  </p>
                ))}
              </div>
              <div className="col pre-scrollable">
                {level2List.map((item) => (
                  <p
                    aria-hidden="true"
                    className={_class(level2, item)}
                    onClick={() => {
                      level2Click(item);
                    }}
                    key={item.code}
                  >
                    {item.name}
                  </p>
                ))}
              </div>
              <div className="col pre-scrollable">
                {level3List.map((item) => (
                  <p
                    aria-hidden="true"
                    className={_class(level3, item)}
                    onClick={() => {
                      level3Click(item);
                    }}
                    key={item.code}
                  >
                    {item.name}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            确定
          </button>
        </div>
      </ul>
    </>
  );
};

const Industry = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [qiwangzhiwei, setQiwangzhiwei] = useState(0);

  const [qiwanghangye, setQiwanghangye] = useState(0);

  // const [industry, setIndustry] = useState([]);

  const [level1, setLevel1] = useState([]);

  const [level2, setLevel2] = useState([]);

  const { id } = useParams();

  const { search } = useLocation();

  const [resume, setResume] = useState({});

  useEffect(() => {
    const fun = () => {
      fetch("/crate-api/setting?option=filterBy-category-refId&category=行业&refId=0")
        .then((res) => res.json())
        .then((res) => {
          if (res) {
            localStorage.setItem(
              "industry",
              JSON.stringify({
                date: Number.parseInt(dayjs().add(7, "days").format("YYYYMMDD"), 10),
                data: res,
              }),
            );
            setLevel1(res);
          } else {
            console.info("服务器错误，请稍后重试");
          }
        });
    };

    const _industry = localStorage.getItem("industry");
    if (_industry !== null) {
      const industry = JSON.parse(_industry);
      if (industry.date - dayjs().format("YYYYMMDD") < 1) {
        fun();
      } else {
        setLevel1(industry.data);
      }
    } else {
      fun();
    }
  }, [id, search]);

  useEffect(() => {
    if (level1 && level1.length > 0) {
      // setLevel1(industry.filter((item) => item.master_id === 0));
      fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
        .then((response) => {
          if (response.status < 400) return response.json();
          throw new Error("请求数据失败");
        })
        .then((res) => {
          if (res) {
            setResume(res);
            if (res.qiwanghangye) {
              const l1 = level1.find((item) => item.detail.name === res.qiwanghangye);
              if (l1) {
                fetch(
                  `/crate-api/setting?option=filterBy-category-refId&category=行业&refId=${l1.id}`,
                )
                  .then((response) => response.json())
                  .then((data) => {
                    setLevel2(data);
                  });
                // setLevel2(level1.filter((item) => item.master_id === l1.id));
              }
            }
            setQiwangzhiwei(() => res.qiwangzhiwei);
            setQiwanghangye(() => res.qiwanghangye);
          } else {
            console.info("服务器错误，请稍后重试！");
          }
        });
    }
  }, [id, search, level1]);

  const _class = (it1, it2) =>
    it1 === it2.detail.name ? "text-primary font-weight-bold" : "text-muted";

  const level1Click = (item) => {
    setQiwanghangye(item.detail.name);
    setQiwangzhiwei(0);
    fetch(`/crate-api/setting?option=filterBy-category-refId&category=行业&refId=${item.id}`)
      .then((response) => response.json())
      .then((data) => {
        setLevel2(data);
      });
    // setLevel2(level1.filter((it) => it.master_id === item.id));
  };

  const level2Click = (item) => {
    setQiwangzhiwei(item.detail.name);
  };

  const handleSave = () => {
    if (qiwangzhiwei === 0) {
      alert("请选择您所期望的职位");
      return;
    }
    fetch(`/gin-api/resume/${resume.uuid}/${resume.id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ...resume,
        addressLevel1: resume.address1 || resume.addressLevel1 || "",
        addressLevel2: resume.address2 || resume.addressLevel2 || "",
        addressLevel3: resume.address3 || resume.addressLevel3 || "",
        addressLevel4: resume.address4 || resume.addressLevel4 || "",
        dateBegin: resume.date_begin,
        dateEnd: resume.date_end,
        qiwangzhiwei,
        qiwanghangye,
      }),
    }).then((res) => {
      if (res.status !== 200) {
        return;
      }
      const industry_data = JSON.parse(sessionStorage.getItem("industry_data"));
      if (industry_data !== null) {
        setResume(industry_data);
      }
      sessionStorage.setItem(
        "industry_data",
        JSON.stringify({
          ...industry_data,
          qiwangzhiwei,
          qiwanghangye,
        }),
      );
      saveJournal({
        ref_id: auth.id,
        ref_uuid: auth.uuid,
        ref_id2: resume.id,
        ref_uuid2: resume.uuid,
        category: "修改简历求职意向",
        tag: "个人用户",
      });
      // _EditJournal(
      //   {
      //     category2: '简历',
      //     data_id: resume.id,
      //     data_uuid: resume.uuid,
      //     remark: '修改简历求职意向',
      //   },
      //   () => {},
      // );
      history.back();
    });
    // .then((res) => res.json())
    // .then((res) => {
    //   if (res.message) {
    //     console.info('服务器错误');
    //   } else {
    //     const industry_data = JSON.parse(sessionStorage.getItem('industry_data'));
    //     if (industry_data !== null) {
    //       setResume(industry_data);
    //     }
    //     sessionStorage.setItem(
    //       'industry_data',
    //       JSON.stringify({
    //         ...industry_data,
    //         qiwangzhiwei,
    //         qiwanghangye,
    //       }),
    //     );
    //     _EditJournal(
    //       {
    //         category2: '简历',
    //         data_id: resume.id,
    //         data_uuid: resume.uuid,
    //         remark: '修改简历求职意向',
    //       },
    //       () => {},
    //     );
    //     history.back();
    //   }
    // });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded shadow">
          <br />
          <ToBack />
          <div className="card-body">
            <div className="mt-2">
              <h4>请选择行业</h4>
            </div>
            <hr />
            <div className="row mt-3" style={{ fontSize: 14 }}>
              <div className="col pre-scrollable">
                {level1.map((item, inx) => (
                  <p
                    aria-hidden="true"
                    className={_class(qiwanghangye, item)}
                    onClick={() => level1Click(item)}
                    key={item.code + inx.toString()}
                  >
                    {item.detail.name}
                  </p>
                ))}
              </div>
              <div className="col pre-scrollable">
                {level2.map((item, inx) => (
                  <p
                    aria-hidden="true"
                    className={_class(qiwangzhiwei, item)}
                    onClick={() => level2Click(item)}
                    key={item.code + inx.toString()}
                  >
                    {item.detail.name}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            确定
          </button>
        </div>
      </ul>
    </>
  );
};

const Project = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [data, setData] = useState({});
  const [recordlist, setRecordList] = useState([]);
  const [data1, setData1] = useState({});
  const [number, setNumber] = useState();
  const { id } = useParams();
  const [content, setContent] = useState("");
  const [content1, setContent1] = useState("");
  const record_data = JSON.parse(sessionStorage.getItem("record_data"));

  const { search } = useLocation();

  useEffect(() => {
    setNumber(Number(getQueryString("index")));
    if (record_data !== null) {
      setData(record_data);
    }
    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setData1(data);
        setRecordList(JSON.parse(data.record));
      });
    // fetch(`/api/resume/user/${id}${search}`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     if (res) {
    //       setData1(res);
    //     } else {
    //       console.info(res);
    //     }
    //   });
  }, [id]);

  const getQueryString = (name) => {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = search.substring(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    const role_content = content.replace(/<\/?.+?>/g, "");
    const description_content = content1.replace(/<\/?.+?>/g, "");
    const recordData = {
      name: data.name,
      title: data.title,
      date_begin: data.date_begin,
      date_end: data.date_end,
      role: role_content,
      description: description_content,
    };
    if (number === 0) {
      fetch(`/gin-api/resume/${data1.uuid}/${data1.id}?option=record`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          record: JSON.stringify(recordlist.concat(JSON.stringify(recordData))),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data1.id,
              ref_uuid2: data1.uuid,
              category: "新增项目经历",
              tag: "个人用户",
            });
            history.back();
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
    } else {
      const record = recordlist;
      const role_content = content.replace(/<\/?.+?>/g, "");
      const description_content = content1.replace(/<\/?.+?>/g, "");
      record.splice(
        number - 1,
        1,
        JSON.stringify({
          ...data,
          role: role_content,
          description: description_content,
        }),
      );
      fetch(`/gin-api/resume/${data1.uuid}/${data1.id}?option=record`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          record: JSON.stringify(record),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data1.id,
              ref_uuid2: data1.uuid,
              category: "修改项目经历",
              tag: "个人用户",
            });
            history.back();
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
      // fetch(`/api/biz/simple/resume/${data1.id}?option=record`, {
      //   method: 'PUT',
      //   headers: { 'content-type': 'application/json' },
      //   body: JSON.stringify({
      //     record: record,
      //   }),
      // }).then((res) => {
      //   if (res.status !== 200) {
      //     console.info('服务器错误');
      //     return;
      //   }
      //   saveJournal({
      //     ref_id: auth.id,
      //     ref_uuid: auth.uuid,
      //     ref_id2: data.id,
      //     ref_uuid2: data.uuid,
      //     category: '修改简历证书',
      //     tag: '个人用户',
      //   });
      //   history.back();
      // });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>项目经历</h6>
            </div>
            <div className="row">
              <InputField
                name="name"
                category="项目名称"
                value={data.name}
                placeholder="请填写参加的项目名称"
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <InputField
                name="title"
                category="项目职位"
                value={data.title}
                placeholder="请填写你所担任的职位"
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">开始时间</label>
                <div className="col">
                  <input
                    type="date"
                    name="date_begin"
                    value={data.date_begin || ""}
                    className="form-control-plaintext input-f"
                    placeholder="项目开始时间"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">结束时间</label>
                <div className="col">
                  <input
                    type="date"
                    name="date_end"
                    value={data.date_end || ""}
                    className="form-control-plaintext input-f"
                    placeholder="项目结束时间"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col">
                <div className="form-group">
                  <ReactQuill
                    formats={["align", "bold", "indent"]}
                    modules={{
                      toolbar: [[{ align: [] }], ["bold"], [{ indent: "-1" }, { indent: "+1" }]],
                    }}
                    placeholder="请填写你参加的项目职责"
                    value={content || data.role || ""}
                    onChange={setContent}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col">
                <div className="form-group">
                  <ReactQuill
                    formats={["align", "bold", "indent"]}
                    modules={{
                      toolbar: [[{ align: [] }], ["bold"], [{ indent: "-1" }, { indent: "+1" }]],
                    }}
                    placeholder="请填写你参加的项目描述"
                    value={content1 || data.description || ""}
                    onChange={setContent1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};
const Work = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [data, setData] = useState({});
  const [data1, setData1] = useState({});
  const [careerlist, setCareerList] = useState([]);
  const [number, setNumber] = useState();

  const { id } = useParams();
  const { search } = useLocation();

  const [content, setContent] = useState("");

  const career_data = JSON.parse(sessionStorage.getItem("career_data"));

  useEffect(() => {
    setNumber(Number(getQueryString("index")));
    if (career_data !== null) {
      setData(career_data);
    }
    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setData1(data);
        setCareerList(JSON.parse(data.career));
      });
    // fetch(`/api/resume/user/${id}${search}`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     if (res) {
    //       setData1(res);
    //     } else {
    //       console.info(res);
    //     }
    //   });
  }, [id]);

  const getQueryString = (name) => {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = search.substring(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    const content1 = content.replace(/<\/?.+?>/g, "");
    const careerData = {
      employer: data.employer,
      title: data.title,
      date_begin: data.date_begin,
      date_end: data.date_end,
      description: content1,
    };
    if (number === 0) {
      fetch(`/gin-api/resume/${data1.uuid}/${data1.id}?option=career`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          career: JSON.stringify(careerlist.concat(JSON.stringify(careerData))),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data1.id,
              ref_uuid2: data1.uuid,
              category: "新增工作经历",
              tag: "个人用户",
            });
            history.back();
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
    } else {
      const career = careerlist;
      const content1 = content.replace(/<\/?.+?>/g, "");
      career.splice(number - 1, 1, JSON.stringify({ ...data, description: content1 }));
      fetch(`/gin-api/resume/${data1.uuid}/${data1.id}?option=career`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          career: JSON.stringify(career),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data1.id,
              ref_uuid2: data1.uuid,
              category: "修改工作经历",
              tag: "个人用户",
            });
            history.back();
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
      // fetch(`/api/biz/simple/resume/${data1.id}?option=career`, {
      //   method: 'PUT',
      //   headers: { 'content-type': 'application/json' },
      //   body: JSON.stringify({
      //     career: career,
      //   }),
      // }).then((res) => {
      //   if (res.status !== 200) {
      //     console.info('服务器错误');
      //     return;
      //   }
      //   saveJournal({
      //     ref_id: auth.id,
      //     ref_uuid: auth.uuid,
      //     ref_id2: data.id,
      //     ref_uuid2: data.uuid,
      //     category: '修改简历证书',
      //     tag: '个人用户',
      //   });
      //   history.back();
      // });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>工作经历</h6>
            </div>
            <div className="row">
              <InputField
                name="employer"
                category="公司名称"
                value={data.employer}
                placeholder="请填写公司名称"
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <InputField
                name="title"
                category="职位名称"
                value={data.title}
                placeholder="请填写你所担任的职位"
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">入职时间</label>
                <div className="col">
                  <input
                    type="date"
                    name="date_begin"
                    value={data.date_begin || ""}
                    className="form-control-plaintext input-f"
                    placeholder="入职时间"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">离职时间</label>
                <div className="col">
                  <input
                    type="date"
                    name="date_end"
                    value={data.date_end || ""}
                    className="form-control-plaintext input-f"
                    placeholder="离职时间"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col">
                <div className="form-group">
                  <ReactQuill
                    formats={["align", "bold", "indent"]}
                    modules={{
                      toolbar: [[{ align: [] }], ["bold"], [{ indent: "-1" }, { indent: "+1" }]],
                    }}
                    placeholder="请填写你的工作描述"
                    value={content || data.description || ""}
                    onChange={setContent}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

const Status = () => {
  const [data, setData] = useState({});
  // const [resume, setResume] = useState(0);
  const auth = JSON.parse(localStorage.getItem("auth"));
  const { id } = useParams();
  // const { search } = useLocation();

  useEffect(() => {
    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setData(data);
      });
    // fetch(`/api/resume/user/${id}${search}`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     if (res) {
    //       setResume(res.id);
    //       fetch(`/api/biz/resume/${res.id}?option=&uuid=${res.uuid}`)
    //         .then((res) => res.json())
    //         .then((res) => {
    //           if (res) {
    //             setData(res);
    //           }
    //         });
    //     } else {
    //       console.info(res);
    //     }
    //   });
  }, [id]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    fetch(`/gin-api/resume/${data.uuid}/${data.id}`, {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ...data,
        addressLevel1: data.address1 || data.addressLevel1 || "",
        addressLevel2: data.address2 || data.addressLevel2 || "",
        addressLevel3: data.address3 || data.addressLevel3 || "",
        addressLevel4: data.address4 || data.addressLevel4 || "",
        dateBegin: data.date_begin,
        dateEnd: data.date_end,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          saveJournal({
            ref_id: auth.id,
            ref_uuid: auth.uuid,
            ref_id2: data.id,
            ref_uuid2: data.uuid,
            category: "修改简历",
            tag: "个人用户",
          });
          history.back();
        } else throw new Error("操作失败");
      })
      .catch((err) => alert(err));
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>求职状态</h6>
            </div>

            <div aria-hidden="true" className="row mt-3">
              <SelectField
                name="status"
                category="求职状态"
                value={data.status}
                handleChange={handleChange}
              >
                <option> </option>
                <option>在职，正在找工作</option>
                <option>离职，正在找工作</option>
                <option>在职，看看机会</option>
                <option>在职，暂不找工作</option>
                <option>在校生</option>
              </SelectField>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

const Certificate = () => {
  const [data, setData] = useState({});
  const [data1, setData1] = useState({});
  const [number, setNumber] = useState();
  const [certificatelist, setCertificateList] = useState([]);
  const auth = JSON.parse(localStorage.getItem("auth"));
  const { id } = useParams();

  const { search } = useLocation();
  const certificate_data = JSON.parse(sessionStorage.getItem("certificate_data"));

  useEffect(() => {
    setNumber(Number(getQueryString("index")));
    if (certificate_data !== null) {
      setData(certificate_data);
    }
    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setData1(data);
        setCertificateList(JSON.parse(data.certificate));
      });
  }, [id]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const getQueryString = (name) => {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = search.substring(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  };

  const handleSave = () => {
    if (number === 0) {
      fetch(`/gin-api/resume/${data1.uuid}/${data1.id}?option=certificate`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          certificate: JSON.stringify(certificatelist.concat(JSON.stringify(data))),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data1.id,
              ref_uuid2: data1.uuid,
              category: "新增简历证书",
              tag: "个人用户",
            });
            history.back();
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
    } else {
      const certificate = certificatelist;
      certificate.splice(number - 1, 1, JSON.stringify(data));
      fetch(`/api/biz/simple/resume/${data1.id}?option=certificate`, {
        method: "PUT",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          certificate: JSON.stringify(certificate),
        }),
      }).then((res) => {
        if (res.status !== 200) {
          return;
        }
        saveJournal({
          ref_id: auth.id,
          ref_uuid: auth.uuid,
          ref_id2: data.id,
          ref_uuid2: data.uuid,
          category: "修改简历证书",
          tag: "个人用户",
        });
        history.back();
      });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>证书</h6>
            </div>

            <div aria-hidden="true" className="row mt-3">
              <InputField
                name="certificate"
                category="证书名称"
                value={data.certificate}
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">获得时间</label>
                <div className="col">
                  <input
                    type="month"
                    name="time"
                    value={data.time || ""}
                    className="form-control-plaintext input-f"
                    placeholder="选择时间"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

const Skill = () => {
  const [data, setData] = useState({});
  const [data1, setData1] = useState({});
  const [number, setNumber] = useState();
  const [skilllist, setSkillList] = useState([]);
  const auth = JSON.parse(localStorage.getItem("auth"));
  const skill_data = JSON.parse(sessionStorage.getItem("skill_data"));
  const { id } = useParams();

  const { search } = useLocation();

  useEffect(() => {
    setNumber(Number(getQueryString("index")));
    if (skill_data !== null) {
      setData(skill_data);
    }
    fetch(`/gin-api/resume?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setData1(data);
        setSkillList(JSON.parse(data.skill));
      });
  }, [id]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const getQueryString = (name) => {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = search.substring(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  };

  const handleSave = () => {
    if (number === 0) {
      fetch(`/gin-api/resume/${data1.uuid}/${data1.id}?option=skill`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          skill: JSON.stringify(skilllist.concat(JSON.stringify(data))),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data1.id,
              ref_uuid2: data1.uuid,
              category: "新增简历专业技能",
              tag: "个人用户",
            });
            history.back();
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
    } else {
      const skill = skilllist;
      skill.splice(number - 1, 1, JSON.stringify(data));
      fetch(`/gin-api/resume/${data1.uuid}/${data1.id}?option=skill`, {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          skill: JSON.stringify(skill),
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            saveJournal({
              ref_id: auth.id,
              ref_uuid: auth.uuid,
              ref_id2: data1.id,
              ref_uuid2: data1.uuid,
              category: "修改简历专业技能",
              tag: "个人用户",
            });
            history.back();
          } else throw new Error("操作失败");
        })
        .catch((err) => alert(err));
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card mt-4 mb-5 bg-white rounded border-0 rounded">
          <ToBack category="我的简历" />
          <div className="card-body">
            <div className="resume-personal pt-2 pb-1 text-center">
              <h6>专业技能</h6>
            </div>

            <div aria-hidden="true" className="row mt-3">
              <InputField
                name="name"
                category="技能名称"
                value={data.name}
                handleChange={handleChange}
              />
            </div>
            <div className="row">
              <div className="form-group row input-label">
                <label className="col-4 col-form-label text-right text-muted">使用时长</label>
                <div className="col">
                  <input
                    type="number"
                    name="length"
                    value={data.length || ""}
                    className="form-control-plaintext input-f"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-3" style={{ display: "table" }}>
                  <span style={{ verticalAlign: "middle", display: "table-cell" }}>个月</span>
                </div>
              </div>
            </div>
            <div aria-hidden="true" className="row mt-3">
              <SelectField
                name="level"
                category="掌握程度"
                value={data.level}
                handleChange={handleChange}
              >
                <option> </option>
                <option>一般</option>
                <option>良好</option>
                <option>熟练</option>
                <option>精通</option>
              </SelectField>
            </div>
          </div>
        </div>
      </div>
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <button type="button" className="btn btn-primary nav-btn" onClick={handleSave}>
            保存
          </button>
        </div>
      </ul>
    </>
  );
};

export default UserRouter;
